import apiClient from './apiClient';

const withSignal = (signal) => signal ? { signal } : {};

export const getOverview = async (range = '30d', options = {}) => {
  const response = await apiClient.get('/agency/overview', {
    params: { range },
    ...withSignal(options.signal),
  });
  return response.data;
};

export const getCampaignSummary = async (campaignId, options = {}) => {
  if (!campaignId) throw new Error('campaignId is required');
  const response = await apiClient.get(`/campaigns/${campaignId}/operational-summary`, withSignal(options.signal));
  return response.data;
};

export const getCampaignSummaries = async (campaignIds, options = {}) => {
  const ids = [...new Set((campaignIds || []).filter(Boolean).map(String))];
  if (ids.length === 0) return [];
  const chunks = [];
  for (let index = 0; index < ids.length; index += 100) chunks.push(ids.slice(index, index + 100));
  const responses = await Promise.all(chunks.map((chunk) => apiClient.get('/campaigns/operational-summaries', {
    params: { ids: chunk.join(',') },
    ...withSignal(options.signal),
  })));
  return responses.flatMap((response) => response.data?.summaries || []);
};

const agencyOverviewService = { getOverview, getCampaignSummary, getCampaignSummaries };

export default agencyOverviewService;
